import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';

// devices routing
const User = Loadable(lazy(() => import('../../settings/UserManagement/users/User')));
const PermissionLevels = Loadable(lazy(() => import('../../settings/UserManagement/permission-levels/PermissionLevelService')));

// ==============================|| MAIN ROUTING ||============================== //

const CustomUserRoutes = {
    path: 'userManagement',
    children: [
        {
            path: 'users',
            element: <User />
        },
        {
            path: 'permissionLevels',
            element: <PermissionLevels />
        }
    ]
};

export default CustomUserRoutes;
